<template>
  <div class="question2" :style="`background: url('${require('../assets/bg20.png')}'); background-size: 100% 100%;`">
    <img class="sub-logo2" src="../assets/logo5.png">
    <div class="content">
      <div class="body">
          <div class="header">
            <img src="../assets/head4.png">
            <div class="title">
              <p class="title_1">抑郁自测量表</p>
            </div>
        </div>

          <div class="q" v-for="(item,index) in qusertion">
              <van-row class="q_title">
                {{ item.title }}
              </van-row>
              <div class="clear"></div>
              <van-radio-group v-model="q[item.model]" :id="item.model">
                <van-radio name="A">A. 没有或很少时间</van-radio>
                <van-radio name="B">B. 小部分时间</van-radio>
                <van-radio name="C">C. 相当多时间</van-radio>
                <van-radio name="D">D. 绝大部分或全部时间</van-radio>
              </van-radio-group>
          </div>
          <div class="q_other">21. 最想做的3件事情</div>
          <div>
              <van-field
                class="q3"
                v-model="q_1"
                center
                clearable
                label="1"
                label-width ="10px"
              >
              </van-field>
          </div>
          <div>
              <van-field
                class="q3"
                v-model="q_2"
                center
                clearable
                label="2"
                label-width ="10px"
              >
              </van-field>
          </div>
          <div>
              <van-field
                class="q_2"
                v-model="q_3"
                center
                clearable
              label="3"
              label-width ="10px"
              >
              </van-field>
          </div>


          <div class="apply2">
              <van-button type="info" class="apply_title" @click="submit()">提交</van-button>
          </div>
      </div>
    </div>
     <div class="footer"  @click="goback()">
      <img class="goback" src="../assets/goback.png" >
    </div>
    <share></share>
  </div>
</template>

<script>
import { Http } from '@/utils/http.js'
import api   from '@/config/api.js'
// import validator from '@/utils/validator.js'
import Cookies from 'js-cookie'
// import AreaList from '@/utils/area'
// import { pca, pcaa } from 'area-data'
import axios from 'axios'

// 1、我觉得闷闷不乐，情绪低沉（忧郁）
// *2、我觉得一天中早晨最好（晨重夜轻）
// 3、一阵阵哭出来或觉得想哭（易哭）
// 4、我晚上睡眠不好（睡眠障碍）
// *5、我吃得跟平常一样多（食欲减退）
// *6、我与异性密切接触时和以往一样感到愉快（性兴趣减退）
// 7、我发觉我的体重在下降（体重减轻）
// 8、我有便秘的苦恼（便秘）
// 9、心跳比平常快（心悸）
// 10、我无缘无故地感到疲乏（易倦）
// *11、我的头脑和平常一样清楚（思考困难）
// *12、我觉得经常做的事情并没有困难（能力减退）
// 13、我觉得不安而平静不下来（不安）
// *14、我对未来抱有希望（绝望）
// 15、我比平常容易生气激动（易激惹）
// *16、我觉得做出决定是容易的（决断困难）
// *17、我觉得自己是个有用的人，有人需要我（无用感）
// *18、我的生活过得很有意思（生活空虚感）
// 19、我认为如果我死了，别人会生活得更好（无价值感）
// *20、平常感兴趣的事我仍然感兴趣（兴趣丧失） [1] 


export default {
  name: 'Question2',
  data() {
    return {
      qusertion: [
        {
          model: 'q1',
          title: '1. 我觉得闷闷不乐，情绪低沉',
          type: 1
        },
        {
          model: 'q2',
          title: '2. 我觉得一天中早晨最好',
          type: 2 
        },
         {
          model: 'q3',
          title: '3. 一阵阵哭出来或觉得想哭',
          type: 1 
        },
        {
          model: 'q4',
          title: '4. 我晚上睡眠不好',
          type: 1
        },
         {
          model: 'q5',
          title: '5. 我吃得跟平常一样多',
          type: 2
        },
        {
          model: 'q6',
          title: '6. 我与异性密切接触时和以往一样感到愉快',
          type: 2
        },
         {
          model: 'q7',
          title: '7. 我发觉我的体重在下降',
          type: 1
        },
        {
          model: 'q8',
          title: '8. 我有便秘的苦恼',
          type: 1
        },
         {
          model: 'q9',
          title: '9. 心跳比平常快',
          type: 1
        },
        {
          model: 'q10',
          title: '10. 我无缘无故地感到疲乏',
          type: 1
        },
         {
          model: 'q11',
          title: '11. 我的头脑和平常一样清楚',
          type: 2
        },
        {
          model: 'q12',
          title: '12. 我觉得经常做的事情并没有困难',
          type: 2
        },
         {
          model: 'q13',
          title: '13. 我觉得不安而平静不下来',
          type: 1
        },
        {
          model: 'q14',
          title: '14. 我对未来抱有希望',
          type: 2
        },
         {
          model: 'q15',
          title: '15. 我比平常容易生气激动',
          type: 1
        },
         {
          model: 'q16',
          title: '16. 我觉得做出决定是容易的',
          type: 2
        },
        {
          model: 'q17',
          title: '17. 我觉得自己是个有用的人，有人需要我',
          type: 2
        },
         {
          model: 'q18',
          title: '18. 我的生活过得很有意思',
          type: 2
        },
        {
          model: 'q19',
          title: '19. 我认为如果我死了，别人会生活得更好',
          type: 1
        },
         {
          model: 'q20',
          title: '20. 平常感兴趣的事我仍然感兴趣',
          type: 2
        }
      ],
      q_1: '',
      q_2: '',
      q_3: '',
      id: 0, // 最想去的地方
      q: [],
      isSubmit: false,
      type1: [],
      type2: []
    };
  },

 methods: {
     // 返回上一页
    goback(){
      this.$router.go(-1)
    },
    // 判断是否答题
    isAnswer(q, answer){
      if(answer.length == 0){
        this.$dialog.alert({
          message: '第' +q + '题没有选择'
        });
        return false;
      }
      return true
    },
     // 弹框
    customAlert(msg){
      this.$dialog.alert({
          message: msg
      });
      return
    },
     // 弹框 确定后返回列表
    customAlert2(msg){
      this.$dialog.alert({
          message: msg
      }).then(
        ()=> {
         // this.$router.go(-1);//返回上一层
        }
      )
      return
    },
    // 获取分数
    getScore(answer,type) {
      var score = 0
      if(type == 1){
        switch(answer){
          case 'A':
              score = 1
            break
          case 'B':
              score = 2
            break
          case 'C':
              score = 3
            break
          case 'D':
              score = 4
            break
        }
      }else{
         switch(answer){
          case 'A':
              score = 4
            break
          case 'B':
              score = 3
            break
          case 'C':
              score = 2
            break
          case 'D':
              score = 1
            break
        }
      }
      return score
    },
    // 判断类型
    getQuestionType(q){
      if(this.type1.includes(q)){
        return 1
      }
      if(this.type2.includes(q)){
        return 2
      }
    },
    // 获取用户最想做的事情
    getAnswer2(){
      let data = {}
      data.uid = this.uid
      Http.post(api.getAnswer2, data).then((response) => {
        if(Object.keys(response.data).length > 0){
          console.log('kkkkkk2222')
          this.id = response.data.id
          const answer = JSON.parse(response.data.answer);
          this.q_1 = answer.q_1
          this.q_2 = answer.q_2
          this.q_3 = answer.q_3
        } 
        return false
      })

      return false;
    },
    // 提交数据
    submit(){
      if(this.isSubmit){
        this.customAlert('正在提交')
        return false
      }
      // 判断是否楼选
      console.log('题目')
      console.log(Object.keys(this.q).length)
      if(Object.keys(this.q).length < 20){
        this.customAlert('还有选项没有选择')
        return false
      }
      this.isSubmit = true
      // 计算总分
      // 提交数据
      let data = {}
      data.uid = Cookies.get('uid');
      data.question = 2;
      data.answer = this.q;
      // 计算总分
      var totalScore = 0
      for (let value in this.q) {
        let type = this.getQuestionType(value)
        totalScore = totalScore + this.getScore(this.q[value], type)
      }
      totalScore = parseInt(totalScore * 1.25)
      data.answer.totalScore = totalScore
      let answer2 = {}
      answer2.q_1 = this.q_1
      answer2.q_2 = this.q_2
      answer2.q_3 = this.q_3
      data.answer2 = answer2
      data.id = this.id
      Http.post(api.answer, data).then((response) => {
          this.isSubmit = false
          if(response.code == 1){
            // 提交成功
            this.customAlert('提交成功')
            this.$router.push({ name: "Result1", query: { score: totalScore } })
            return false
          }else{
            // 发送失败
            this.customAlert(response.msg)
            return false
          }
      })

      return false;
    }
  },
  mounted: function() {
    // uid 如果不存在则根据openid 获取uid
    this.uid = Cookies.get('uid')
    // 如果用户ID 不存在去首页
    // 根据uid 获取最想去的地方的答题数据
    if(this.uid){
      this.getAnswer2()
    }
    for (let value in this.qusertion) {
        if(this.qusertion[value].type == 1){
          this.type1.push(this.qusertion[value].model)
        }else{
          this.type2.push(this.qusertion[value].model)
        }
    }
     document.title = 'SDS抑郁自评量表'
  }

};
</script>

<style lang="less">
.question2 {
  font-size: 16px;
   display: flex;
    height: 100vh;
    flex-direction: column;

     .sub-logo2 {
        position: absolute;
        width: 40px;
        top: 20px;
        right: 20px;    
    }
  .content {
    position: relative;
    overflow: hidden;
    height: 90%;
    background-color: #fff;
    margin: 60px 20px;
    .el-input--suffix {
      width: 160px;
    }
    .el-input__icon {
      line-height: 22px;
    }
    .el-input--suffix .el-input__inner {
      padding-right: 18px;
      height: 30px;
    }
    .van-field__label {
      width: 120px;
    }
    .van-cell {
      font-size: 16px;
    }
    .van-col {
      margin-bottom: 20px;
    }
    .van-field__body {
      border-bottom: 2px solid #f7f7f7;
    }
    .van-picker__cancel {
      display: none;
    }
    .van-picker__title {
      margin-left: 20px;
      color: #58585d;
      background: #fff;
    }
     .van-radio__label { 
      font-size: 12px;
    }
    .clear{
      clear:both
    }
    .van-radio {
      margin: 12px;
    }
    .van-checkbox {
      margin-left: 12px;
    }
    .van-checkbox__label {
      margin: 12px;
      text-align: left;
    }

    .other{
      padding: 0px;
      text-align: left;
    }
    .body {
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    overflow-x: hidden;
    overflow-y: scroll;
    .header {
      position: relative;
      img {
        width: 100%;
        display: block;
      }
      .title {
        .title_1 {
          position: absolute;
          top: 36px;
          font-size: 20px;
          left: 30px;
          color: #34afe8;
        }
      }
    }
      margin-left: 12px;
      .q {
        margin-left: 16px;
        margin-right: 12px;
        .q_title {
          float: left;
          text-align: left;
        }
      }
      .q_other {
        margin-left: 16px;
      }
    .apply2 {
        text-align: center;
        margin-bottom: 12px;
        // position: relative;
       // margin-top: 24px;
        .apply_title {
          // position: absolute;
          // left: 50%;
          // transform: translate3d(-50%,-50%,0);
            width: 100px;
              height: 40px;
              border-radius: 4px;
              font-size: 18px;
          color: #007bf7;
          background-color: #fff;
          border-radius: 1rem;
          margin-bottom: 12px;
        }
      }
    }
  }
    .footer {
      position: fixed;
      bottom: 0px;
      right: 0;
      .goback {
        width: 120px
      }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Question2.vue